import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';

import { mapCreditData, mapCreditEditData } from './creditClient.formatter';

const creditsApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const editCredit = (data: Credit.Edit): Promise<AxiosResponse<Credit.Credit>> => {
  return request({
    options: {
      url: `${creditsApiBaseUrl}/credits/${data.id}/`,
      method: 'PUT',
      data: mapCreditEditData(data),
    },
  }).then((data: AxiosResponse<Credit.CreditApi>) => ({
    ...data,
    data: mapCreditData(data.data),
  }));
};

export const creditClient = {
  editCredit,
};